const TaxonomyPage = {
    HOMEPAGE: '/homepage/',
    HOME_VALUES: '/home-values/',
    VALUATION: '/valuation/',
    PRIVACY: '/privacy/',
    DISCOVER: '/discover/',
    PROPERTY: '/property/details/', // Not the actual URL, but differentiates from other /property/ URLs
    FOR_SALE_SEARCH_RESULTS: '/for-sale/results/',
    FOR_SALE_DETAILS: '/for-sale/details/',
    FOR_SALE_CONTACT: '/for-sale/contact/',
    TO_RENT_SEARCH_RESULTS: '/to-rent/results/',
    TO_RENT_DETAILS: '/to-rent/details/',
    TO_RENT_CONTACT: '/to-rent/contact/',
    NEW_HOMES_SEARCH_RESULTS: '/new-homes/results/',
    NEW_HOMES_DETAILS: '/new-homes/details/',
    NEW_HOMES_CONTACT: '/new-homes/contact/',
    SIGN_IN: '/signin/',
    REGISTER: '/register/',
    SCHEMES_HELP_TO_BUY: '/schemes/help-to-buy/',
    SCHEMES_HELP_TO_BUY_SCOTLAND: '/schemes/help-to-buy/scotland/',
    SCHEMES_HELP_TO_BUY_WALES: '/schemes/help-to-buy/wales/',
    SCHEMES_SHARED_OWNERSHIP: '/schemes/shared-ownership/',
    AGENT_PORTFOLIO: '/agent-portfolio/'
} as const;

const TaxonomySection = {
    HOMEPAGE: 'homepage',
    HOME_VALUES: 'home-values',
    HOUSE_PRICES: 'house-prices',
    FOR_SALE: 'for-sale',
    TO_RENT: 'to-rent',
    NEW_HOMES: 'new-homes',
    PRIVACY: 'privacy',
    DISCOVER: 'discover',
    SIGN_IN: 'signin',
    REGISTER: 'register',
    HELP_TO_BUY: 'help-to-buy',
    SHARED_OWNERSHIP: 'shared-ownership',
    NEW_HOMES_SEARCH: 'new homes/developers',
    AGENT_PORTFOLIO: 'agent-portfolio'
} as const;

export const getSegmentData = (pathname: string) => {
    const currentPath = pathname.replace(/(\/\[.+\]$)/, '');

    const keyMap: Record<
        string,
        [keyof typeof TaxonomyPage, keyof typeof TaxonomySection]
    > = {
        '/': ['HOMEPAGE', 'HOMEPAGE'],
        '/home-values': ['HOME_VALUES', 'HOME_VALUES'],
        '/valuation': ['VALUATION', 'HOUSE_PRICES'],
        '/privacy': ['PRIVACY', 'PRIVACY'],
        '/discover': ['DISCOVER', 'DISCOVER'],
        '/for-sale': ['FOR_SALE_SEARCH_RESULTS', 'FOR_SALE'],
        '/for-sale/details': ['FOR_SALE_DETAILS', 'FOR_SALE'],
        '/to-rent': ['TO_RENT_SEARCH_RESULTS', 'TO_RENT'],
        '/to-rent/details': ['TO_RENT_DETAILS', 'TO_RENT'],
        '/new-homes': ['NEW_HOMES_SEARCH_RESULTS', 'NEW_HOMES'],
        '/new-homes/details': ['NEW_HOMES_DETAILS', 'NEW_HOMES'],
        '/property': ['PROPERTY', 'HOUSE_PRICES'],
        '/signin': ['SIGN_IN', 'SIGN_IN'],
        '/register': ['REGISTER', 'REGISTER']
    };

    const pageKey = keyMap[currentPath]
        ? keyMap[currentPath][0]
        : ('HOMEPAGE' as const);
    const sectionKey = keyMap[currentPath]
        ? keyMap[currentPath][1]
        : ('HOMEPAGE' as const);

    return {
        page: TaxonomyPage[pageKey],
        section: TaxonomySection[sectionKey]
    };
};
